import $ from "jquery";
import "./../styles/main.scss";
require("jquery.scrollto");
import GLightbox from 'glightbox';
// require("./helpers/ihavecookies");
require("./helpers/Siema");
$(document).ready(function () {
    var lightbox = GLightbox({
        touchNavigation: true,
        loop: true
    });
    setTimeout(function () {
        $("#pop-up").addClass("view").on("click", ".close a", function (e) {
            e.preventDefault();
            $("#pop-up").fadeOut(500);
        });
    }, 500);
    $(".symbol").on("click", function (e) {
        e.preventDefault();
        $("#main-header").toggleClass("open");
    });
    if ($(".page-template-tpl-home").length) {
        setTimeout(function () {
            // $('#home-header').css({ height: "auto" });
        }, 500);
        $('#home-header .siema-wrapper').animate({ opacity: 1 }, 500);
    }
    $("body").on("click", "a[href^='#goto-']", function (e) {
        e.preventDefault();
        var node = $(e.currentTarget).attr("href").replace("goto-", "");
        var posY = $(node).offset().top - $("#main-header").height();
        if (posY >= 0) {
            $.scrollTo(posY, 400);
        }
    });
    $('.blockItem').on("click", ".header a", function (e) {
        e.preventDefault();
        var closeButton = $(e.currentTarget).children(".close");
        var openButton = $(e.currentTarget).children(".open");
        var parent = $(e.currentTarget).parent().next();
        if (openButton.is(":hidden")) {
            closeButton.fadeOut(300, function () { openButton.fadeIn(); });
            parent.fadeToggle(300);
        }
        else {
            openButton.fadeOut(300, function () { closeButton.fadeIn(); });
            parent.delay(300).fadeToggle(300);
        }
    });
    $(".menu-item-has-children > a").on("click", function (e) {
        e.preventDefault();
        $(e.currentTarget).parent().toggleClass("open");
    });
    $('body').on("click", ".shared-item", function (e) {
        e.preventDefault();
        window.open($(e.currentTarget).attr("href"), "", "width=500,height=350");
    });
    $("body").on("click", "#menu-switcher a", function (e) {
        e.preventDefault();
        $("#nav-main").toggleClass("show-menu");
        $(e.currentTarget).toggleClass("show-menu");
    });
    $("body").on("click", ".goTo", function (e) {
        var elm = $(e.currentTarget).attr("href");
        var posY = $(elm).offset().top - $("#main-header").height();
        $.scrollTo(posY, 400);
    });
});
